import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.5, staggerChildren: 0.12 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' }
  }
};

const WhoAreWeSection = () => (
  <motion.section
    className="bg-white w-full py-16 md:py-20 font-sans"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.35 }}
    variants={containerVariants}
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid md:grid-cols-[0.9fr,1.1fr] gap-10 items-start">
        {/* Left: Heading */}
        <motion.div variants={itemVariants}>
          <h2
            className="text-3xl md:text-5xl font-bold text-neutral-900"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Who we are
          </h2>
        </motion.div>

        {/* Right: Copy */}
        <motion.div variants={itemVariants}>
          <p className="text-base md:text-lg text-neutral-800 leading-relaxed">
            Lincoln AIM is a global tech recruitment firm connecting elite talent with
            innovative companies across the UK, US, and MENA. With offices in Dubai,
            London, and New York, our diverse team of 30+ professionals brings deep
            market insight, speed, and precision to every search.
          </p>
          <p className="mt-6 text-base md:text-lg text-neutral-800 leading-relaxed">
            We partner with startups, financial institutions, and tech leaders—matching
            them with the people who drive performance and impact.
          </p>
        </motion.div>
      </div>
    </div>
  </motion.section>
);

export default WhoAreWeSection;
